export default "__VITE_ASSET__Dt90HB3U__"